import { PayloadAction } from '@reduxjs/toolkit';

import { StartupType as Startup } from 'packages/startup_repository';
import { startupDef } from 'redux/utils';
import { SetAllType, SetFieldType, types } from './actions';

const initialState: Startup = startupDef;

const handleSetAll = (state: Startup, payload: SetAllType) => payload.startup;

const handleSetField = (state: Startup, payload: SetFieldType) => ({ ...state, [payload.field]: payload.value });

const reducer = (state: Startup, action: PayloadAction<SetAllType | SetFieldType>) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_ALL: {
      return handleSetAll(state, <SetAllType>payload);
    }
    case types.SET_FIELD: {
      return handleSetField(state, <SetFieldType>payload);
    }
    default:
      return state;
  }
}

export { reducer, initialState };
